Controller = App.loadClass 'core::Angular/Controller'

class exports.FieldSelectionController extends Controller
    constructor: (
        @scope,
        @transitions,
        @modal,
        @http,
        @service,
        @state
    ) ->
        super

        @http.get 'api/fields'
        .then (response) =>
            @fields = _.sortBy response.data, 'farm_name', 'field_name'
                .map (field) =>
                    field.selected = false
                    return field

        @http.get('api/nitrogen-surveys')
        .then (response) =>
            @surveys = _.filter response.data, (survey) =>
                survey.year is @service.year

    fieldName: (field) =>
        "#{field?.farm_name} - #{field?.field_name}"

    cropThatPreventsFieldBeingSelected: (field) =>
        if not @surveys?
            return true

        if @service.crop in ['Corn (grain)', 'Sorghum']
            otherSurvey = _.find @surveys, (survey) =>
                survey.crop.name in ['Corn (grain)', 'Sorghum'] and survey.crop.name isnt @service.crop

            if not otherSurvey
                return null

            if _.find otherSurvey.fields_nitrogen_surveys, { fields_id: field.fields_id }
                return otherSurvey.crop.name

        return null

    rxMapDeliveredForField: (field) =>
        @service.rxMaps[field.fields_id]?.length > 0

    fieldSelected: (field) =>
        _.find @service.survey?.fields_nitrogen_surveys, fields_id: field.fields_id

    selectField: (field) =>
        if not @fieldSelected field
            @service.survey.fields_nitrogen_surveys.push
                fields_id: field.fields_id
                field_name: field.field_name
                farm_name: field.farm_name
                complete: false
                data: {}

                # This data is just dummy data so we don't get errors. In reality, the
                # events data for each field will get overwritten as soon as the survey
                # is saved in the next step.
                events: {
                    planting: []
                    fertilizer: []
                    spraying: []
                }
                growth_stage_last_updated: null

    deselectField: (field) =>
        if @fieldSelected field
            _.remove @service.survey.fields_nitrogen_surveys, (value) =>
                value.fields_id is field.fields_id

    toggleFieldSelection: (field) =>
        if @fieldSelected field
            @deselectField field
        else
            @selectField field

    selectAll: () =>
        for field in @fields
            if not @cropThatPreventsFieldBeingSelected(field)
                @selectField field

    deselectAll: () =>
        for field in @fields
            if not @rxMapDeliveredForField(field)
                @deselectField field

    countUnselectedFields: () =>
        if not @fields
            return 1

        _.filter @fields, (field) =>
            not @fieldSelected(field) and not @cropThatPreventsFieldBeingSelected(field)
        .length
